export default [
  {
    path: '/vehicle/list',
    name: 'vehicle-list',
    meta: {
      breadcrumb: [
        { text: 'conf.title' },
        { text: 'conf.vehicle.title', active: true },
      ],
      pageTitle: 'conf.vehicle.title',
      // ROLE_CONFIG_MANAGEMENT must be able to reach the list: it can open the
      // edit screen and is redirected here after deleting a vehicle. This also
      // matches the navigation menu, which already exposes the list to that role.
      roles: ['ROLE_DISPATCHER', 'ROLE_CONFIG_MANAGEMENT'],
    },
    component: () => import('@/views/vehicles/VehicleList/VehicleList'),
  },
  {
    path: '/vehicle/edit/:id',
    name: 'vehicle-edit',
    meta: {
      breadcrumb: [
        { text: 'conf.title' },
        { text: 'conf.vehicle.title', to: '/vehicle/list' },
        { text: 'conf.vehicle.edit_vehicle', active: true },
      ],
      pageTitle: 'conf.vehicle.title',
      roles: ['ROLE_CONFIG_MANAGEMENT'],
    },
    component: () => import('@/views/vehicles/VehicleEdit/VehicleEdit'),
  },
]
